export const host = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://trisdauvergne-inspirit.herokuapp.com';
